
export default {
    props: {
        customLocalization: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            loading: true,
            emptyPerson: '',
            emptyPersonFemale: '',
            emptyPersonMale: '',
            lazyLoadItem: '',
            store: null,
            storeState: {state: null},
            loc_name: null,
            maskAccountId: d => d,
            aid: null
        }
    },
    created: function () {
        this.beforeCreateMethod();
        if (!window.MLMSoftUICore)
            window.addEventListener('singletonCreated', () => {
                this.store = window.MLMSoftUICore.instance.getStore();
                this.createdMethod();
            });
        else {
            this.store = window.MLMSoftUICore.instance.getStore();
            this.createdMethod();
        }
    },
    mounted() {
        let fFR;
        let that = this;
        if (!window.MLMSoftUICore)
            window.addEventListener('singletonCreated', () => {
                let store = window.MLMSoftUICore.instance.getStore();
                fFR = store.state.fontFamilyRe;
                if (fFR)
                    setFontFamily(fFR)
            });
        else {
            fFR = this.store.state.fontFamilyRe;
            if (fFR)
                setFontFamily(fFR)
        }

        function setFontFamily(ff) {
            const body_ref = that.$refs.body;
            if (body_ref)
                body_ref.style.fontFamily = ff
        }

    },
    computed: {
        locale() {
            return this.storeState.state ? this.storeState.state.locale : null;
        },
        isLoggedIn() {
            return this.storeState.state ? this.storeState.state.isLoggedIn : null;
        },
        getInfoDefP() {
            return undefined;
        }
    },
    watch: {
        locale(newLocale) {
            if (newLocale)
                // if (this.isLoggedIn)
                //     this.isLoggedIn_(true);
                if (this.$i18n){
                    this.$i18n.locale = newLocale;
                    this.localeChange();
                }
        },
        isLoggedIn(newValue) {
            this.isLoggedIn_(newValue);
        }
    },
    methods: {
        isLoggedIn_(newValue) {
            if (newValue) {
                this.preGetInfo();
            } else {
                this.postGetInfo();
                this.loading = true;
            }
        },
        mapDownlineFirst(list, useDifferentPosition) {

            let multiPositions    = [];
            let mappedListByProps = list.map((item) => {

                // seeking duplicates/multiPositions
                if (item?.treePosition) {
                    list.forEach(item2 => {

                        if (item.id === item2.id && item2?.treePosition && item.treePosition.id !== item2.treePosition.id) {
                            item.isDuplicate = true;
                            multiPositions.push(item2); // add other existing duplicates
                        }
                        
                    });
                }
                // ---------------------------------


                const isTreePositionArray = (item?.treePosition && Array.isArray(item.treePosition) && item.treePosition[0]?.properties);
                const isTreePositionObj   = (item?.treePosition && !Array.isArray(item.treePosition) && item.treePosition?.properties);
                let treePosition          = null;

                if (!item?.properties) {
                    item['properties'] = [];

                    treePosition = isTreePositionArray ? item.treePosition[0] : (isTreePositionObj ? item.treePosition : null);
                    if (treePosition) {
                        item.properties = treePosition.properties;
                    }
                } else {
                    treePosition = isTreePositionArray ? item.treePosition[0] : (isTreePositionObj ? item.treePosition : null);
                    if (treePosition) {
                        item.properties = item.properties.concat(treePosition.properties);
                    }
                }

                if (treePosition && useDifferentPosition) {
                    item.accountId        = treePosition.accountId;
                    item.createdAt        = treePosition.createdAt;
                    item.id               = treePosition.id;
                    item.number           = treePosition.number;
                    item.offset           = treePosition.offset;
                    item.parentPosition   = treePosition?.parentPosition;
                    item.parentPositionId = treePosition.parentPositionId;
                    item.spillLeg         = treePosition.spillLeg;
                    item.treeId           = treePosition.treeId;
                    item.treeLevel        = treePosition.treeLevel;
                }

                return item;
            });

            if (multiPositions.length) {
                console.log('multiPositions', JSON.stringify(multiPositions));
                multiPositions = multiPositions.map((item) => {
                    item.rootId = item.id;
                    item.id     = item.treePosition.id;
                    return item;
                });

                mappedListByProps.forEach((item) => {
                    if (item.isDuplicate == undefined) {
                        multiPositions.push(item);
                    }
                });

                return multiPositions;
            } else {
                return mappedListByProps;
            }
            
        },
        localeChange() {

        },
        preGetInfo() {
            if (this.getInfoDefP === undefined)
                this.getInfo();
            else
                this.getInfo(...this.getInfoDefP);
        },
        postGetInfo() {

        },
        beforeCreateMethod() {
        },
        createdMethod() {
            this.maskAccountId = window.MLMSoftUICore.formatAccountId;
            this.getAp();
            if (this.loc_name){
                this.store.dispatch('getLocalizationModule', {module: this.loc_name, i18n: this.$i18n, customLocalization: this.customLocalization}).then(() => {
                    this.storeState.state = this.store.state;
                });
            }
            else
                this.storeState.state = this.store.state;
            this.emptyPerson = this.store.state.emptyPerson;
            this.emptyPersonFemale = this.store.state.emptyPersonFemale;
            this.emptyPersonMale = this.store.state.emptyPersonMale;
            this.lazyLoadItem = this.store.state.lazyLoadItem;
        },
        getInfo() {

        },
        getAp() {

        }
    }
}
